import { Facebook, Instagram, Youtube, MessageCircle, Search } from 'lucide-react';

// Platform configurations
export const platforms = {
  fb: { icon: Facebook, color: '#1877F2', label: 'Facebook', shortLabel: 'FB' },
  ig: { icon: Instagram, color: '#E4405F', label: 'Instagram', shortLabel: 'IG' },
  tt: { icon: () => <span className="text-[10px] font-bold">TT</span>, color: '#000000', label: 'TikTok', shortLabel: 'TT' },
  tg: { icon: MessageCircle, color: '#0088CC', label: 'Telegram', shortLabel: 'TG' },
  gg: { icon: Search, color: '#4285F4', label: 'Google', shortLabel: 'GG' },
  yt: { icon: Youtube, color: '#FF0000', label: 'YouTube', shortLabel: 'YT' },
};

// Month names
export const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const shortMonthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Forex pairs
export const forexPairs = ['XAUUSD', 'EURUSD', 'GBPUSD', 'USDJPY', 'AUDUSD', 'USDCAD', 'NZDUSD', 'USDCHF', 'GBPJPY', 'EURJPY'];
export const positions = ['BUY', 'SELL'];
export const tradeStatuses = ['WIN', 'LOSS', 'BREAKEVEN'];

// Channel options for signals
export const channelOptions = [
  { value: 'public', label: 'Public', color: '#3B82F6' },
  { value: 'vip', label: 'VIP', color: '#F59E0B' },
  { value: 'both', label: 'Both', color: '#8B5CF6' },
];

// Default broker configuration
export const defaultBrokerConfig = {
  brokerA: { name: 'Octa', enabled: true },
  brokerB: { name: 'HFM', enabled: true },
  brokerC: { name: 'Vantage', enabled: true },
  brokerD: { name: '', enabled: false },
  brokerE: { name: '', enabled: false },
};

// Default marketing data
export const defaultMarketingData = [
  {
    id: 1, date: '2026-01-01',
    spend: { fb: 150, ig: 120, tt: 80, tg: 50, gg: 30, yt: 20 },
    impressions: { fb: 45000, ig: 35000, tt: 25000, tg: 12000, gg: 5000, yt: 3000 },
    clicks: { fb: 1200, ig: 900, tt: 600, tg: 300, gg: 150, yt: 50 },
    lpv: 850, cta: 420, subsTG: 180, subsBot: 95,
  },
  {
    id: 2, date: '2026-01-02',
    spend: { fb: 130, ig: 100, tt: 70, tg: 40, gg: 25, yt: 15 },
    impressions: { fb: 38000, ig: 28000, tt: 18000, tg: 9000, gg: 3500, yt: 1500 },
    clicks: { fb: 1000, ig: 800, tt: 500, tg: 300, gg: 150, yt: 50 },
    lpv: 720, cta: 350, subsTG: 140, subsBot: 70,
  },
  {
    id: 3, date: '2026-01-03',
    spend: { fb: 180, ig: 140, tt: 90, tg: 60, gg: 35, yt: 15 },
    impressions: { fb: 52000, ig: 42000, tt: 28000, tg: 15000, gg: 5500, yt: 2500 },
    clicks: { fb: 1500, ig: 1100, tt: 750, tg: 450, gg: 200, yt: 100 },
    lpv: 980, cta: 510, subsTG: 220, subsBot: 115,
  },
];

// Default sales data
export const defaultSalesData = [
  {
    id: 1, date: '2026-01-01',
    leadsM: { new: 15, prospect: 8, vip: 3 },
    leadsS: { new: 12, prospect: 6, vip: 2 },
    leadsIB: { new: 10, prospect: 5, vip: 2 },
    closed: 8,
    brokerA: { active: 120, lots: 45.5, commission: 2250, deposit: 15000 },
    brokerB: { active: 85, lots: 32.0, commission: 1580, deposit: 9500 },
    brokerC: { active: 45, lots: 18.5, commission: 920, deposit: 5200 },
    greeting: 12, oneTick: 8, registration: 6, broker: 5, priceOffer: 4, others: 7,
  },
  {
    id: 2, date: '2026-01-02',
    leadsM: { new: 12, prospect: 6, vip: 2 },
    leadsS: { new: 10, prospect: 5, vip: 1 },
    leadsIB: { new: 8, prospect: 4, vip: 1 },
    closed: 6,
    brokerA: { active: 118, lots: 42.0, commission: 2100, deposit: 12500 },
    brokerB: { active: 82, lots: 28.5, commission: 1420, deposit: 8200 },
    brokerC: { active: 44, lots: 15.0, commission: 750, deposit: 4800 },
    greeting: 10, oneTick: 6, registration: 5, broker: 4, priceOffer: 3, others: 11,
  },
];

// Default operation data
export const defaultOperationData = [
  {
    date: '2026-01-01',
    trades: [
      { id: 1, pair: 'XAUUSD', position: 'BUY', status: 'WIN', pips: 45, channel: 'both' },
      { id: 2, pair: 'EURUSD', position: 'SELL', status: 'WIN', pips: 28, channel: 'public' },
      { id: 3, pair: 'GBPUSD', position: 'BUY', status: 'LOSS', pips: -15, channel: 'vip' },
      { id: 4, pair: 'XAUUSD', position: 'SELL', status: 'WIN', pips: 32, channel: 'both' },
    ]
  },
  {
    date: '2026-01-02',
    trades: [
      { id: 5, pair: 'XAUUSD', position: 'BUY', status: 'WIN', pips: 52, channel: 'both' },
      { id: 6, pair: 'USDJPY', position: 'SELL', status: 'LOSS', pips: -22, channel: 'vip' },
    ]
  },
  {
    date: '2026-01-03',
    trades: [
      { id: 7, pair: 'XAUUSD', position: 'BUY', status: 'WIN', pips: 38, channel: 'public' },
      { id: 8, pair: 'EURUSD', position: 'BUY', status: 'WIN', pips: 18, channel: 'both' },
      { id: 9, pair: 'GBPJPY', position: 'SELL', status: 'WIN', pips: 45, channel: 'vip' },
      { id: 10, pair: 'AUDUSD', position: 'BUY', status: 'LOSS', pips: -12, channel: 'public' },
      { id: 11, pair: 'XAUUSD', position: 'SELL', status: 'WIN', pips: 28, channel: 'both' },
    ]
  },
];

// Initial form states
export const initialMarketingEntry = {
  date: '',
  spend: { fb: 0, ig: 0, tt: 0, tg: 0, gg: 0, yt: 0 },
  impressions: { fb: 0, ig: 0, tt: 0, tg: 0, gg: 0, yt: 0 },
  clicks: { fb: 0, ig: 0, tt: 0, tg: 0, gg: 0, yt: 0 },
  lpv: 0, cta: 0, subsTG: 0, subsBot: 0, leads: 0, closed: 0,
};

export const initialSalesEntry = {
  date: '',
  leadsM: { new: 0, prospect: 0, vip: 0 },
  leadsS: { new: 0, prospect: 0, vip: 0 },
  leadsIB: { new: 0, prospect: 0, vip: 0 },
  closed: 0,
  brokerA: { active: 0, lots: 0, commission: 0, deposit: 0 },
  brokerB: { active: 0, lots: 0, commission: 0, deposit: 0 },
  brokerC: { active: 0, lots: 0, commission: 0, deposit: 0 },
  brokerD: { active: 0, lots: 0, commission: 0, deposit: 0 },
  brokerE: { active: 0, lots: 0, commission: 0, deposit: 0 },
  greeting: 0, oneTick: 0, registration: 0, broker: 0, priceOffer: 0, others: 0,
};

export const initialOperationEntry = {
  date: '',
  pair: 'XAUUSD',
  position: 'BUY',
  status: 'WIN',
  pips: 0,
  channel: 'both', // public, vip, or both
};
